module.exports = __webpack_public_path__ + "static/media/movieflix.f7458823.svg";